"use strict";
/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
Object.defineProperty(exports, "__esModule", { value: true });
exports.ArrowCDownIcon16Light = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var forwardRef_1 = require("../../helpers/forwardRef");
var BaseIcon_1 = require("../../internal/BaseIcon");
exports.ArrowCDownIcon16Light = forwardRef_1.forwardRef('ArrowCDownIcon16Light', function (props, ref) {
    return (react_1.default.createElement(BaseIcon_1.BaseIcon, tslib_1.__assign({ ref: ref, viewBoxSize: 16 }, props),
        react_1.default.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M3.146 5.647a.5.5 0 0 1 .708 0l3.792 3.792a.5.5 0 0 0 .708 0l3.792-3.792a.5.5 0 0 1 .708.707L9.06 10.147a1.5 1.5 0 0 1-2.122 0L3.146 6.354a.5.5 0 0 1 0-.707Z" })));
});
